import { render, staticRenderFns } from "./XSurvey.vue?vue&type=template&id=198f60c1"
import script from "./XSurvey.vue?vue&type=script&lang=js"
export * from "./XSurvey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports